/**
 * @generated SignedSource<<78a1b5027ebac99e07765f88170cb5d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RSVPToEventInput = {
  eventId?: string | null;
  occurrenceId?: string | null;
  productId?: string | null;
};
export type RecurringEventConfirmAttendanceModalMutation$variables = {
  input: RSVPToEventInput;
};
export type RecurringEventConfirmAttendanceModalMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly occurrences: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly atCapacity: boolean;
          readonly hasViewerRSVPd: boolean;
          readonly rsvps: {
            readonly totalCount: number;
          } | null;
        };
      }>;
    } | null;
  };
};
export type RecurringEventConfirmAttendanceModalMutation = {
  response: RecurringEventConfirmAttendanceModalMutation$data;
  variables: RecurringEventConfirmAttendanceModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasViewerRSVPd",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "atCapacity",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "OccurrenceRSVPNodeConnection",
  "kind": "LinkedField",
  "name": "rsvps",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RecurringEventConfirmAttendanceModalMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "RSVPToEventResponse",
        "kind": "LinkedField",
        "name": "rsvpToEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OccurrenceNodeConnection",
            "kind": "LinkedField",
            "name": "occurrences",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OccurrenceNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Occurrence",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RecurringEventConfirmAttendanceModalMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "RSVPToEventResponse",
        "kind": "LinkedField",
        "name": "rsvpToEvent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OccurrenceNodeConnection",
            "kind": "LinkedField",
            "name": "occurrences",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OccurrenceNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Occurrence",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a82fb67fb18168f3ec297c5efa151bbb",
    "id": null,
    "metadata": {},
    "name": "RecurringEventConfirmAttendanceModalMutation",
    "operationKind": "mutation",
    "text": "mutation RecurringEventConfirmAttendanceModalMutation(\n  $input: RSVPToEventInput!\n) {\n  response: rsvpToEvent(input: $input) {\n    occurrences {\n      edges {\n        node {\n          hasViewerRSVPd\n          atCapacity\n          rsvps {\n            totalCount\n          }\n          id\n        }\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9721e2fa53a33f1357288c4093534bc7";

export default node;
